/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
import d3 from '../globalexports/d3.export';

const preBootstrapUpdate = () => {
  const content = {};
  content.oneTimeUpdateKeyPreBootstrap = 20240428;
  content.bn_preBootstrapLastOtuOn = 'bn_preBootstrapLastOtuOn';
  content.quotaExceed = 'QuotaExceededError';
  content.oneTimePreBootstrapUpdate = async () => {
    let myDevicePreviousSettings = localStorage.getItem('bn_deviceSpecificSetting');
    let myMeteoPreviousSettings = localStorage.getItem('bn_meteogramSetting');
    let myRouteprofilePreviousSettings = localStorage.getItem('bn_routeprofileSetting');
    if (myDevicePreviousSettings) {
      myDevicePreviousSettings = JSON.parse(myDevicePreviousSettings);
    }
    if (myMeteoPreviousSettings) {
      myMeteoPreviousSettings = JSON.parse(myMeteoPreviousSettings);
    }
    if (myRouteprofilePreviousSettings) {
      myRouteprofilePreviousSettings = JSON.parse(myRouteprofilePreviousSettings);
    }
    let lsOtuOn = localStorage.getItem(content.bn_preBootstrapLastOtuOn);
    if (lsOtuOn !== null) {
      // Parse it to Integer
      lsOtuOn = parseInt(lsOtuOn, 10);
    }
    if (lsOtuOn === null || lsOtuOn < content.oneTimeUpdateKeyPreBootstrap) {
      if (lsOtuOn < 20180208) {
        if (myDevicePreviousSettings) {
          myDevicePreviousSettings.enableLoginFlow = true;
        }
      }
      if (lsOtuOn < 20180420) {
        if (myMeteoPreviousSettings) {
          myMeteoPreviousSettings.maximumAltitudeAllowed = 12000;
        }
        if (myRouteprofilePreviousSettings) {
          myRouteprofilePreviousSettings.maximumAltitudeAllowed = 12000;
        }
      }
      if (lsOtuOn < 20180716) {
        if (myDevicePreviousSettings) {
          myDevicePreviousSettings.sliderDelayEtd = 500;
        }
      }
      // if (lsOtuOn < 20190419) {
      //   const avwxUser = localStorage.getItem('bn_avwxUser');
      //   const avwxUserOld = localStorage.getItem('bn_avwxUserOld');
      //   if (avwxUser) {
      //     secureLsService.setInfo(
      //       AppConst.localstorageConf.avwxUser,
      //       JSON.parse(window.atob(avwxUser)),
      //     );
      //     secureLsService.setInfo(
      //       AppConst.localstorageConf.uc,
      //       JSON.parse(window.atob(avwxUser)),
      //     );
      //   }
      //   if (avwxUserOld) {
      //     try {
      //       secureLsService.setInfo(
      //         AppConst.localstorageConf.avwxUserOld,
      //         JSON.parse(window.atob(avwxUserOld)),
      //       );
      //     } catch (ee) {
      //       console.log(ee);
      //     }
      //   }
      // }
      // if (lsOtuOn < 20210403) {
      //   if (myDevicePreviousSettings) {
      //     delete myDevicePreviousSettings.enablePremiumUser;
      //   }
      // }
      // if (lsOtuOn < 20210405) {
      //   if (myDevicePreviousSettings) {
      //     delete myDevicePreviousSettings.enablePremiumUser;
      //   }
      //   const avwxUser_v2 = secureLsService.getInfo(AppConst.localstorageConf.avwxUser);
      //   if (avwxUser_v2 && avwxUser_v2.email) {
      //     secureLsService.setInfo(AppConst.localstorageConf.uc_copy, {
      //       Username: avwxUser_v2.email,
      //       Password: avwxUser_v2.password,
      //     });
      //   }
      // }
      if (lsOtuOn < 20210716) {
        if (myDevicePreviousSettings) {
          myDevicePreviousSettings.enableRadarFeature = true;
        }
      }
      if (lsOtuOn < 20210725) {
        if (myDevicePreviousSettings) {
          myDevicePreviousSettings.stormTrackDuplicateRange = 4000;
        }
      }
      // if (lsOtuOn < 20210806) {
      //   if (myDevicePreviousSettings) {
      //     myDevicePreviousSettings.enableRadarFeature = false;
      //   }
      // }
      // if (lsOtuOn < 20210911) {
      //   if (myDevicePreviousSettings) {
      //     myDevicePreviousSettings.enableRadarFeature = true;
      //   }
      // }
      // if (lsOtuOn < 20210916) {
      //   if (myDevicePreviousSettings) {
      //     myDevicePreviousSettings.enableRadarFeature = false;
      //   }
      // }
      if (lsOtuOn < 20211011) {
        const lastStateKey = localStorage.getItem('bn_lastStateKey');
        if (lastStateKey) {
          localStorage.setItem('bn_lastViewedStateKey', lastStateKey);
        }
      }
      if (lsOtuOn < 20211028) {
        if (myDevicePreviousSettings) {
          myDevicePreviousSettings.enableRadarFeature = true;
        }
      }
      if (lsOtuOn < 20211201) {
        let bnSuppressedMets = localStorage.getItem('bn_suppressedMets');
        try {
          if (bnSuppressedMets) {
            bnSuppressedMets = JSON.parse(bnSuppressedMets);
            if (bnSuppressedMets.indexOf('Radar') < 0) {
              bnSuppressedMets.push('Radar');
              bnSuppressedMets.push('Storm Track');
              localStorage.setItem('bn_suppressedMets', JSON.stringify(bnSuppressedMets));
            }
          }
        } catch (ex) {
          console.log(ex);
        }
      }
      if (lsOtuOn < 20211207) {
        const serviceHostPref = localStorage.getItem('bn_serviceHost');
        if (serviceHostPref) {
          localStorage.setItem('bn_serviceHost', 'https://app.weatherspork.com');
        }
      }
      if (lsOtuOn < 20240428) {
        const tu = localStorage.getItem('bn_tu');
        if (tu && /^\d+$/.test(tu)) {
          localStorage.setItem('bn_tu', new Date(parseInt(tu, 10)).toISOString());
        }
      }
    }
    if (myDevicePreviousSettings) {
      localStorage.setItem('bn_deviceSpecificSetting', JSON.stringify(myDevicePreviousSettings));
    }
    if (myMeteoPreviousSettings) {
      localStorage.setItem('bn_meteogramSetting', JSON.stringify(myMeteoPreviousSettings));
    }
    if (myRouteprofilePreviousSettings) {
      localStorage.setItem('bn_routeprofileSetting', JSON.stringify(myRouteprofilePreviousSettings));
    }
    localStorage.setItem(content.bn_preBootstrapLastOtuOn, content.oneTimeUpdateKeyPreBootstrap);
  };
  content.checkIfNotPrivate = () => {
    try {
      localStorage.setItem('testinglocal', 'testinglocal');
      return true;
    } catch (ex) {
      if (ex.name === content.quotaExceed) {
        d3.select('#privateBrowsing').style('display', 'block');
      }
      return false;
    }
  };
  content.checkJavaScriptEnabled = () => {
    try {
      return localStorage;
    } catch (ex) {
      console.log(ex);
      d3.select('#privateBrowsing').style('display', 'block');
      return null;
    }
  };
  /**
     * detect IE
     * returns version of IE or false, if browser is not Internet Explorer
     */
  content.detectIE = () => {
    const ua = window.navigator.userAgent;
    // return true;
    const msie = ua.indexOf('MSIE ');
    if (msie > 0) {
      // IE 10 or older => return version number
      return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    const trident = ua.indexOf('Trident/');
    if (trident > 0) {
      // IE 11 => return version number
      const rv = ua.indexOf('rv:');
      return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    const edge = ua.indexOf('Edge/');
    if (edge > 0) {
      // Edge (IE 12+) => return version number
      return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }

    // other browser
    return false;
  };
  content.checkIfInternetExplorer = () => {
    const version = content.detectIE();
    let showIEWaring = false;
    if (version && version > 1) {
      showIEWaring = true;
      console.log('Browser not supported');
    }
    if (showIEWaring) {
      d3.select('#ieWarning').style('display', 'block');
    }
    return showIEWaring;
  };
  content.isBootstrappingAllowed = async () => (content.checkJavaScriptEnabled()
  && content.checkIfNotPrivate() && !content.checkIfInternetExplorer());
  return content;
};
export default preBootstrapUpdate();
